var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"props-group"},[_c('el-form-item',{attrs:{"label":"禁止粘贴"}},[_c('el-checkbox',{model:{value:(_vm.component.properties.disablePaste),callback:function ($$v) {_vm.$set(_vm.component.properties, "disablePaste", $$v)},expression:"component.properties.disablePaste"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8a98072","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/componentAttr/disable-paste.vue
// module id = null
// module chunks = 